import React from 'react';
import { StyleSheet } from './base_components';

import ProgressSpinner from './progress_spinner';
import Select from './select';

import UserStore from '../stores/user_store';

const styles = StyleSheet.create({
  orgSelect: {
    paddingLeft: '1em',
    width: '20em',
    height: '2em',
    color: 'black',
    fontSize: '1.3em',
    fontWeight: 'bold',
    backgroundColor: '#ccc',
    borderRadius: '0.3em',
  },
});

type Props = {
  style?: any;
  includeList?: any;
  excludeList?: any;
  value: any;
  onChange: any;
};
type State = {
  org_list: any;
};

export default class OrgSelect extends React.PureComponent<Props, State> {
  state = {
    org_list: UserStore.getUser().org_list,
  };

  render() {
    const { style, includeList, excludeList, value, onChange } = this.props;
    const { org_list } = this.state;

    let content = null;
    if (!org_list) {
      content = <ProgressSpinner />;
    } else {
      let valid_list;
      if (includeList) {
        valid_list = includeList;
      } else {
        valid_list = org_list.filter((org) => {
          const { org_id } = org;
          let ret = true;
          if (excludeList) {
            const excluded = excludeList.find((o) => o.org_id === org_id);
            if (excluded) {
              ret = false;
            }
          }
          return ret;
        });
      }
      const options = [
        { value: 0, text: '' },
        ...valid_list.map((v) => ({
          value: v.org_id,
          text: v.org_name,
        })),
      ];

      content = (
        <Select
          style={[styles.orgSelect, style]}
          options={options}
          value={value}
          onChange={onChange}
        />
      );
    }
    return content;
  }
}
